import { createActions } from 'reduxsauce';

export const { Types, Creators } = createActions(
  {
    updateExtendVignetteRoute: ['route'],
    updateBuyVignetteRoute: ['route'],
  },
  {},
);
